//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.ShopResale

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The resale group model
* 
* @param resales The resales in the group
* @param contingentId The resale contingent id
* @param groupDescription The resale group description
* @param groupTitle The resale group title
* @param productId The resale product id
*/
@Serializable

data class ResaleGroup (


      /* The resales in the group */
    @SerialName(value = "resales") @Required val resales: kotlin.collections.List<ShopResale>,


      /* The resale contingent id */
    @SerialName(value = "contingentId") val contingentId: kotlin.Int? = null,


      /* The resale group description */
    @SerialName(value = "groupDescription") val groupDescription: kotlin.String? = null,


      /* The resale group title */
    @SerialName(value = "groupTitle") val groupTitle: kotlin.String? = null,


      /* The resale product id */
    @SerialName(value = "productId") val productId: kotlin.Int? = null


) {




  }

